import { render } from "./BoardFansCategories.vue?vue&type=template&id=ff7cd79e&scoped=true"
import script from "./BoardFansCategories.vue?vue&type=script&lang=js"
export * from "./BoardFansCategories.vue?vue&type=script&lang=js"

import "./BoardFansCategories.vue?vue&type=style&index=0&id=ff7cd79e&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7cd79e"]])

export default __exports__